<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>产品名称：</span>
        <span>{{ item.itemName }}</span>
      </van-row>
      <van-row>
        <span>规格型号：</span>
        <span>{{ item.standard }}</span>
      </van-row>
      <van-row>
        <span>产品数量：</span>
        <span>{{ item.productQty }}</span>
      </van-row>
      <van-row>
        <span>计量单位：</span>
        <span>{{ item.unit | dictFilter(unitOptions) }}</span>
      </van-row>
      <van-row>
        <span>到货日期：</span>
        <span>{{ item.arrivalDate }}</span>
      </van-row>
      <van-row>
        <span>单价(元)：</span>
        <span>{{ item.productPrice }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  data() {
    return {
      // poCreateHeadId: this.$store.getters.businessKey,
      poCreateHeadId: this.$route.query.businessKey
    }
  },
  props: {
    currencyDict: {
      type: String
    },
    detailsList: {
      type: Array
    }
  },
  computed: {
    unitOptions() {
      return this.$store.getters.dicts.bstme
    }
  },
  methods: {}
}
</script>
